import { EventsTimeline } from "@components/EventsTimeline/EventsTimeline"

type TProspectRightSectionProps = {
  prospect_guid: string
}

export const ProspectRightSection = ({
  prospect_guid,
}: TProspectRightSectionProps) => {
  return (
    <div className="tw:bordered-container">
      <EventsTimeline
        prospect_guid={prospect_guid}
        eventType="prospect"
        sectionTitle="Prospect Events"
      />
    </div>
  )
}
